import PageLayout from "../../components/common/page-layout";
import TestOrderView from "../../components/test-orders/test-order-view";
import { RequireAuth } from "../../hooks/use-auth";

/** Route page listing test orders and their expected charges. */
const TestOrderPage = () => {
  return (
    <RequireAuth>
      <PageLayout maxWidth={false} title="Test orders">
        <TestOrderView />
      </PageLayout>
    </RequireAuth>
  );
};

export default TestOrderPage;
